export default "__VITE_ASSET__DuVDvciv__"